<template>

<div class="files-upload">
    <div class="list">

        <div class="file" v-for="(file, index) in value" :key="file.id">
            <div class="thumb" v-if="file.type=='image'" :style="'background-image:url('+thumbUrl(file)+')'"></div>
            <div class="thumb thumb-document" v-if="file.type=='document'" ><i class="fa fa-file-o"></i></div>
            <div class="filename">{{file.filename}}.{{file.extension}}</div>
            <div class="btn btn-delete" @click="remove(index)"><i class="icon icon-sm icon-close"></i></div>
        </div>
        
        <div class="uploading" v-if="uploading">
            <div class="thumb" :style="'background-image:url('+uploading.thumb+')'"></div>
            <div class="filename">
                {{uploading.name}}
                <div class="loader mt-2"><div class="bar"></div></div>
            </div>
        </div>

        <!-- <form enctype="multipart/form-data" @submit.prevent="upload" ref="uploadForm"> -->
            <div class="btn btn-light upload-btn" :class="{'invalid': invalid}" >
                <p>{{placeholder}}</p> 
                    <input type="file" @change="upload"  ref="file">
            </div>

            <!-- <input type="submit"> -->
        <!-- </form> -->
        <div class="invalid-feedback d-block mt-1 mb-4" v-if="invalid">Debe subir al menos una imagen</div>
    </div>
</div>
</template>

<script>
import { uploadFileToGcs } from '@/lib/gcsUpload'
import { resolveFileThumb } from '@/lib/fileUrl'

export default {
	name: "uploadFiles",
	props:{
		value:{
            type: Array,
        },
		placeholder: {
            type: String
        },
		invalid: {
            type: Boolean
        },
		accept: {
            type: String,
            default: null
        },
    },
    data() {
        return {
            uploadedImage:{},
            uploading: null,
            API_URL: process.env.VUE_APP_API_URL,
            filetypes: [
                'doc',
                'docx',
                'xls',
                'xlsx',
                'ppt',
                'pdf',
                'zip',
                'rar',
                '7z',
                'odt',
                'ods',
            ],
            imagetypes: [
                'gif',
                'png',
                'jpeg',
                'jpg',
            ]
        }
    },
	methods:{
        thumbUrl(file) {
            return resolveFileThumb(file)
        },
        checkFile(file){
            if(file){
                var filename = file.name.split(".")
                var extension = filename[filename.length-1].toLowerCase()

                if( this.accept == 'image' && this.imagetypes.includes(extension)){
                    return true
                }
                if( this.accept == 'file' && this.filetypes.includes(extension)){
                    return true
                }
                // si no esta especificado que debe aceptar, me fijo si al menos es un formato aceptado.
                if( !this.accept && ( this.imagetypes.includes(extension) || this.filetypes.includes(extension)) ){
                    return true
                }
            }
            return false
        },
		upload(event){
            console.log(event)
            var input = event.target;
            if( this.checkFile(input.files[0]) ){
                this.$emit('uploading', true)
                this.uploading = input.files[0];
                this.uploading.thumb = URL.createObjectURL(input.files[0]);
                return uploadFileToGcs(this.$apollo, input.files[0])
                .then( file => {
                    if(file){
                        this.value.push(file)
                    }else{
                        this.$toast.error('Error al subir el archivo')
                    }
                    this.uploading = null;
                    this.$emit('uploading', false)
                    this.$emit('changed')
                    return file;
                })
                .catch(err => {
                    console.log(err)
                    this.$toast.error('Error al subir el archivo')
                    this.uploading= null;
                    this.$emit('uploading', false)
                    return false;
                });
            }else{
                this.$toast.error('Archivo no permitido')
            }

		},
		remove(index){
            this.value.splice(index,1)
            this.$emit('changed')
        },
	}
};
</script>

<style scoped lang="scss">

.list{
    width: 100%;
    display: flex;
    flex-direction: column;

    .file{
        width: 100%;
        border: 1px solid rgba(28,110,164,.2);
        margin: 4px 0;
        padding: 4px;
        border-radius: 3px;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #fff;
        flex-grow: 0;
        flex-shrink: 0;   
        cursor: pointer;

        .filename{
            flex-grow: 1;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .btn-delete{
            color: #000;
        }
    }
}
.thumb{
    border-radius: 3px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 48px;
    height: 48px;
    margin-right: 8px;
}

.thumb-document{
    background-color: #ccc;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    i{
        font-size: 18px;
        color: #fff;
    }
}
.uploading{
    width: 100%;
    border: 1px solid rgba(28,110,164,.2);
    margin: 4px 0;
    padding: 4px;
    border-radius: 3px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    flex-grow: 0;
    flex-shrink: 0;   
    cursor: pointer;

    .filename{
        flex-grow: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}

.upload-btn{
    // width: 140px;
    // height: 140px;
    border: 1px solid rgba(28,110,164,.2);
    margin: 4px 0;
    // border-radius: 3px;
    position:relative;
    display: flex;
    align-items: center;
    justify-content:center;
    background-color: #fff; 
    
    flex-grow: 0;
    flex-shrink: 0;
    cursor: pointer;
    
    input{
        opacity:0;
        position: absolute;
        z-index: 10;
        top: 0px;
        width: 100%;
        height: 100%;
        cursor: pointer;
    }
}


 @keyframes loader-animation {
     0% {
         left: -100%;
     }
     49% {
         left: 100%;
     }
     50% {
         left: 100%;
     }
     100% {
         left: -100%;
     }
 }
 .loader {
     height: 5px;
     width: 100%;
     overflow: hidden;
 }
 .loader .bar {
     position: relative;
     height: 2px;
     width: 100%;
     background-color: dodgerblue;
     animation-name: loader-animation;
     animation-duration: 3s;
     animation-iteration-count: infinite;
     animation-timing-function: ease-in-out;
 }

// .file
//     &.invalid{
//         border-color: #dc3545;
//     }
//     &:hover{
//         background-color: #f1f1f1; 
//     }

//     .invalid-feedback{
//         position: absolute;
//         bottom: -22px;
//     }

//     p{
//         margin: 0px;
//         text-transform: uppercase;
//         color: #adb5bd;
//         font-size: 12px;
//         font-weight: 600;
//     }
    
    
//     .loading{
//         position: absolute;
//         border:none;
//         width: 100%;
//         height: 100%;
//         background-color: rgba(0,0,0,0.4); 
//         display: flex;
//         align-items: center;
//         justify-content:center;
//         flex-flow: column;
//         color: #fff;
//         opacity: 1;
//         cursor: pointer;
 
//         i{
//             font-size: 34px;
//         }
//     }

// }

</style>
